import ConfigurationSourceDataForm from "@/components/forms/forms/source-data-configuration/ConfigurationSourceDataForm";
import TrialContext from "@/contexts/data/TrialContext";
import { FC, useContext } from "react";

const ConfigurationSourceDataDetails: FC = () => {
    
    const { data: trial } = useContext(TrialContext);

    return (
        <>
            <ConfigurationSourceDataForm />
        </>
    )
};

export default ConfigurationSourceDataDetails;